import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className='rawb0tsApp__footer'>Rawb0ts is a 0xWarlabs project ©2022</div>
  )
}

export default Footer;